import React from 'react';

const Certifications: React.FC = () => {


    return (
        <section id="certification" className="py-16 bg-gray-50 ">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Certifications</h2>
            <p className="text-lg font-semibold text-gray-900 text-center">
                PCEP - Certified Entry-Level Python Programmer &nbsp;&nbsp;&nbsp;&nbsp; 06/25
            </p>
        </section>
    );
};

export default Certifications;